export default () => (
  (
    window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth
  ) < 981
)
